import { NumberInput as ChakraNumberInput } from '@chakra-ui/react';
import { forwardRef } from 'react';

type NumberInputSize = 'sm' | 'md';

export type NumberInputProps = Omit<ChakraNumberInput.RootProps, 'size'> & {
  placeholder?: string;
  size?: NumberInputSize;
};

const sizeProps: Record<NumberInputSize, ChakraNumberInput.InputProps> = {
  sm: { h: 8 },
  md: { h: 10 },
};

const NumberInput = forwardRef<HTMLDivElement, NumberInputProps>(
  ({ children, placeholder, size = 'md', ...rest }, ref) => (
    <ChakraNumberInput.Root
      variant="outline"
      w="100%"
      size={size}
      ref={ref}
      {...rest}
    >
      <ChakraNumberInput.Input
        background="white"
        border="1px solid"
        borderColor="gray.400"
        focusRing="mixed"
        focusRingColor="blue.500"
        focusRingWidth="1px"
        paddingLeft={2}
        pattern="[0-9]*"
        _hover={{ borderColor: 'gray.500' }}
        _invalid={{
          backgroundColor: 'red.50',
          borderColor: 'red.400',
          focusRingColor: 'red.400',
          _hover: { borderColor: 'red.500' },
        }}
        _disabled={{
          borderColor: 'gray.400 !important',
          background: 'gray.50',
          color: 'gray.400',
          opacity: 1,
        }}
        placeholder={placeholder}
        {...sizeProps[size]}
      />
      <ChakraNumberInput.Control>
        <ChakraNumberInput.IncrementTrigger />
        <ChakraNumberInput.DecrementTrigger />
      </ChakraNumberInput.Control>
    </ChakraNumberInput.Root>
  )
);

export default NumberInput;
